// extracted by mini-css-extract-plugin
export default {"label":"TimefieldComponent_label__uhN9y"};